import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import OrientedCoordinateArray from '../noding/OrientedCoordinateArray';
import ArrayList from '../../../../java/util/ArrayList';
import TreeMap from '../../../../java/util/TreeMap';
var EdgeList = /*#__PURE__*/function () {
  function EdgeList() {
    _classCallCheck(this, EdgeList);
    EdgeList.constructor_.apply(this, arguments);
  }
  _createClass(EdgeList, [{
    key: "print",
    value: function print(out) {
      out.print('MULTILINESTRING ( ');
      for (var j = 0; j < this._edges.size(); j++) {
        var e = this._edges.get(j);
        if (j > 0) out.print(',');
        out.print('(');
        var pts = e.getCoordinates();
        for (var i = 0; i < pts.length; i++) {
          if (i > 0) out.print(',');
          out.print(pts[i].x + ' ' + pts[i].y);
        }
        out.println(')');
      }
      out.print(')  ');
    }
  }, {
    key: "addAll",
    value: function addAll(edgeColl) {
      for (var i = edgeColl.iterator(); i.hasNext();) this.add(i.next());
    }
  }, {
    key: "findEdgeIndex",
    value: function findEdgeIndex(e) {
      for (var i = 0; i < this._edges.size(); i++) if (this._edges.get(i).equals(e)) return i;
      return -1;
    }
  }, {
    key: "iterator",
    value: function iterator() {
      return this._edges.iterator();
    }
  }, {
    key: "getEdges",
    value: function getEdges() {
      return this._edges;
    }
  }, {
    key: "get",
    value: function get(i) {
      return this._edges.get(i);
    }
  }, {
    key: "findEqualEdge",
    value: function findEqualEdge(e) {
      var oca = new OrientedCoordinateArray(e.getCoordinates());
      var matchEdge = this._ocaMap.get(oca);
      return matchEdge;
    }
  }, {
    key: "add",
    value: function add(e) {
      this._edges.add(e);
      var oca = new OrientedCoordinateArray(e.getCoordinates());
      this._ocaMap.put(oca, e);
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._edges = new ArrayList();
      this._ocaMap = new TreeMap();
    }
  }]);
  return EdgeList;
}();
export { EdgeList as default };